// @flow
import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { History } from 'react-router-dom';

import type { Location, Match } from '../../types/router';
import type { RequestsStore } from '../../types/request';
import type { UserStore } from '../../types/user';
import type { AllStatusesStore } from '../../types/status';
import AppView from '../layouts/AppView';
import fetchRequests from '../../actions/requests';
import { allProviderStatuses } from '../../actions/status';
import ProviderCards from '../provider-cards';
import OnboardingStateHeader from '../onboarding-state-header';
import Section from '../shared/PageSection';
import FileViewer from '../shared/FileViewer';
import consentFormService from '../../services/consent-form-service';
import Loader from '../shared/Loader';

type Props = {
  match: Match,
  location: Location,
  requests: RequestsStore,
  user: UserStore,
  history: History,
  statuses: AllStatusesStore,
  activeReqs: number,
  isOverReqLimit: boolean,
  numReqsLeft: number,
  fetchRequests: () => void,
  fetchStatuses: () => void,
  memberStatus: string,
} & WithTranslation

type State = {
  loading: boolean,
  showFormFor: null
}

const mapStateToProps = (appState) => ({
  statuses: appState.allStatuses,
  requests: appState.requests,
  user: appState.user,
  locale: appState.locale
});

const mapDispatchToProps = (dispatch) => ({
  fetchRequests: (() => dispatch(fetchRequests())),
  fetchStatuses: ((ids) => dispatch(allProviderStatuses(ids)))
});

class MyProviders extends Component<Props, State> {
  state: State = {
    loading: false,
    showFormFor: null
  };

  props: Props

  componentWillMount() {
    const { requests } = this.props;
    // to prevent making a call each time
    // users go back to this page
    // for speed
    if ((!requests && requests.data) || (requests.data && requests.data.length === 0)) {
      this.props.fetchRequests();
      this.props.fetchStatuses();
    }
  }

  render() {
    const { requests, user, statuses, t } = this.props;
    const hasMadeRequests = !requests.loading && requests && requests.data && requests.data.length > 0;
    return (
      <AppView>
        {requests.loading &&
          <Loader isLoading />}

        {!requests.loading && !hasMadeRequests &&
          <OnboardingStateHeader
            user={user}
            hasMadeRequests={hasMadeRequests}
            history={this.props.history}
            loading={this.state.loading}
            onClickResendEmail={this.resendEmailVerification}
          />}

        {hasMadeRequests && (
          <Section
            className='providers'
            title={t('my_providers_title')}
            subtitle={
              t('my_providers_subtitle', { count: requests.data.length })
            }
            loading={requests.loading}
          >
            {!requests.loading &&
              <ProviderCards
                addresses={requests.data.map((r) => ({
                  ...r.institution_address,
                  institution: r.institution,
                  institution_id: r.institution_id,
                  request_id: r.id
                }))}
                statuses={statuses && statuses.data}
                showConsentForm={(requestId) => this.setState({ showFormFor: requestId })}
              />}
            {this.state.showFormFor && (
              <FileViewer
                getBlob={consentFormService.getSigned}
                getFileInfo={consentFormService.getFileInfo}
                itemId={this.state.showFormFor}
                onExit={() => this.setState({ showFormFor: null })}
              />
            )}
          </Section>
        )}
      </AppView>
    );
  }
}

export default withTranslation('myProviders')(
  connect(mapStateToProps, mapDispatchToProps)(MyProviders)
);



// WEBPACK FOOTER //
// ./src/components/pages/my-providers.js